import ccFlywheelFeatureDiscovery from '@post-office/team-package--i18n--cc-flywheel-feature-discovery/i18n/en.json';
import postOfficeTemplate from '@post-office/team-package--i18n--post-office-template/i18n/en.json';
import growth from '@post-office/team-package--i18n--growth/i18n/en.json';
import testMessages from '@post-office/team-package--i18n--test-messages/i18n/en.json';

/* eslint-disable @typescript-eslint/no-explicit-any */
const messages: Record<string, any> = {
	...ccFlywheelFeatureDiscovery,
	...postOfficeTemplate,
	...growth,
	...testMessages
}

export default messages;
